import { CLEAR_FAVORITE_COLLECTION, FETCH_FAVORITE_COLLECTION, SET_FAVORITE_COLLECTION } from "../actions";

export const getFavoriteCollection = () => ({
    type: FETCH_FAVORITE_COLLECTION,
});

export const setFavoriteCollection = (favoriteCollection) => ({
    type: SET_FAVORITE_COLLECTION,
    payload: favoriteCollection,
});

export const clearFavoriteCollection = () => ({
    type: CLEAR_FAVORITE_COLLECTION,
});
